module.exports = __webpack_public_path__ + "static/media/Bakgrund-checkout.1b22b993.jpg";